import { motion } from 'framer-motion';

function Footer() {
  return (
    <footer className="bg-[#07111b] py-10 text-white md:py-12">
      <div className="container-asi">
        <div className="grid gap-8 md:grid-cols-[1fr_auto] md:items-start">
          <div>
            <h3 className="mb-3 font-serif text-xl text-white">
              AI Studies Institute
            </h3>
            <p className="mb-0 max-w-xl text-sm leading-6 text-white/62">
              Independent, evidence-first research on AI leverage, deployment
              trajectories, and emerging risk.
            </p>
          </div>

          <div className="text-sm md:text-right">
            <motion.a
              href="mailto:contact@aistudies.institute"
              className="block text-white/82 transition-colors hover:text-asi-copper"
              whileHover={{ x: 2 }}
            >
              contact@aistudies.institute
            </motion.a>
            <p className="mb-0 mt-2 text-white/50">
              Research Triangle Park, NC
            </p>
          </div>
        </div>

        <div className="mt-8 border-t border-white/10 pt-6">
          <p className="mb-0 text-xs leading-6 text-white/42">
            © 2025 AI Studies Institute. ASI is an independent research
            organization based in Research Triangle Park, North Carolina.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
